import React from 'react';

const EventCard = ({ title, date, time, location, description, image, variant }) => {
  return (
    <div className={`event-card ${variant}`}>
      <img src={image} alt={title} />
      <div className="event-content">
        <h3>{title}</h3>
        <p>{description}</p>
        <span>{date} {time} | {location}</span>
      </div>
    </div>
  );
};

export default EventCard;
